module.exports = __webpack_public_path__ + "img/telegram.9ef776ec.svg";